<template>
  <div id="container-title">
    <div id="generic-title">
      <p>Resultado de la consulta</p>
    </div>
    <div id="specific-title">
      <h4>La estación <b>{{ station_name }}</b> tiene <b>{{ dataQuantity }}</b>
      registros desde <b>{{ initDate }}</b> hasta <b>{{ endDate }}</b> </h4>
    </div>
  </div>
  <div class="container">
    <dropDown @changeQuantityPerPage="changePerPage"/>
    <button
      class="downloadButton"
      @click="downloadData()">
      Exportar datos
      <img :src="require('./download.png')">
    </button>
  </div>
    <div class="container-table">
      <table id="table" class="table">
      <thead class="table-header">
        <tr>
          <th class="table-row-title" v-for="(column, index) in columns" :key="index" :title="column">
          <div v-html="column"></div>
          </th>
        </tr>
      </thead>
      <tbody class="table-body">
        <tr v-for="(row, index) in rows" :key="index">
          <td class="table-row-content" v-for="(data, index) in row" :key="index">{{ data }}</td>
        </tr>
      </tbody>
      </table>
    </div>
    <paginationSlide :end="this.totalPages" @changedPage="changeData"/>
</template>

  <script>
  import paginationSlide from "./TablePagination.vue"
  import dropDown from "./TableDropdown.vue"
  import { mapState } from 'vuex'

  export default {
    name: 'Table',
    props: {
      columns: Array,
      rows: Array,
      totalPages: Number,
    },

    emit:['changeData', 'changePerPage', 'downloadData'],

    components: {
      paginationSlide,
      dropDown
    },

    computed: {
      ...mapState(['station_name', 'dataQuantity', 'initDate', 'endDate'])
    },

    methods: {
      changeData(page_number){
        this.$emit('changeData',page_number)
      },
      changePerPage(quantity){
        this.$emit('changePerPage', quantity)
      },
      downloadData(){
        this.$emit('downloadData')
      }
    }
  }
  </script>

  <style scoped>
    #container-title {
    cursor: default;
    display: flex;
    flex-flow: row wrap;
    max-width: 100%;
    text-align: center;
    margin-bottom: 1.2rem;
  }
  #generic-title {
    color: rgb(100, 120, 20);
    margin-top: 1em;
    font-size: 1.7em;
    width: 85%;
    font-family: "Ancizar-bold", Helvetica, Arial;
    margin-left: 9rem;
  }
  #specific-title {
    margin-top: .5em;
    font-size: 1.2em;
    width: 85%;
    font-family: "Ancizar-bold", Helvetica, Arial;
    margin-left: 8rem;
  }
  .container-table{
    display: grid;
    overflow: auto;
    max-height: auto;
    max-width: auto;
    margin: 0rem 1rem 0rem 8rem;
  }
  .table {
    border: .1rem solid rgba(220, 220, 220, 0.616);
  }
  .table-header {
    position: sticky;
  }
  .table-body {
    line-height: 1;
    color: black;
    overflow: auto;
  }
  .table-row-title {
    border-left: .1rem solid gainsboro;
    text-align: center;
    min-width:6rem;
    font-family: "Ancizar-regular", Helvetica, Arial;
  }
  .table-row-content {
    text-align: center;
    font-family: "Ancizar-regular", Helvetica, Arial;
    border-left: .1rem solid rgba(220, 220, 220, 0.616);
    border-bottom: .1rem solid rgba(220, 220, 220, 0.616);
  }
  .container{
    display: grid;
    overflow: auto;
    max-height: auto;
    width: 100%;
    grid-template-columns: 87%;
    margin-left: 7.3rem;
    margin-bottom: 1rem;
  }
  .downloadButton{
    margin-left: 170px;
    max-width: 8.5rem;
    background-color: rgba(55, 55, 55, 0.7);
    color: white;
    border: .12rem solid rgba(0, 0, 0, 0.171);
    padding: .3rem;
    border-radius: .3rem;
    font-family: "Ancizar-regular", Helvetica, Arial;
    align-items: center;
    display: flex;
  }
  .downloadButton > img{
    margin-left: 0.6rem;
    width: 1rem;
  }
  @media (max-width: 769px) {
    .container-table {
      display: flex;
      flex-flow: row wrap;
    }
  }
  </style>